module.exports = "/_next/static/images/logo-d6b77e64.png";